import Injector from 'vue-inject';
import Debug from '@/util/debug';
import url from 'url';
import { addHostToGenericCache, removeHostFromGenericCache } from '@/util/sw-messages';

const debug = Debug('service:AdApiUrl');

export default class AdApiUrlService {
  constructor() {
    this.apiUrl = null;
    this.setUrl('default.adapi.host.example.com') // this will be replaced by InitializerService
      .catch(e => debug.warn('ignored', e));
  }

  setUrl(newUrl) {
    debug.info('setUrl: %s', newUrl);

    return removeHostFromGenericCache(this.apiUrl && url.parse(this.apiUrl).host)
      .then(() => addHostToGenericCache(newUrl && url.parse(newUrl).host))
      .then(this.apiUrl = newUrl)
      .catch(this.apiUrl = newUrl);
  }

  getUrl(version) {
    const versionedUrl = url.resolve(this.apiUrl, version.replace(/\/?$/, '/'));
    debug.info('getUrl(%s): %s', version, versionedUrl);
    return versionedUrl;
  }
}

Injector.service('adApiUrlService', AdApiUrlService);



// WEBPACK FOOTER //
// ./src/services/AdApiUrlService.js